function trimTrailingSlash(value) {
  return value.replace(/\/+$/, "");
}

function localBasePath() {
  if (typeof window === "undefined") {
    return "";
  }

  const firstPathPart = window.location.pathname.split("/").filter(Boolean)[0];
  const appRoutes = new Set([
    "about",
    "contact",
    "expertise",
    "innovation",
    "activities",
    "blog",
    "gallery",
    "admin",
    "wishlist",
    "cart",
    "team",
    "book",
    "published",
    "waiting",
    "login",
    "assets",
    "static",
    "backend",
    "api",
  ]);

  return firstPathPart && !appRoutes.has(firstPathPart.toLowerCase())
    ? `/${firstPathPart}`
    : "";
}

export function appBasename() {
  return process.env.REACT_APP_BASENAME || localBasePath();
}

export function backendBaseUrl() {
  if (process.env.REACT_APP_API_BASE_URL) {
    const raw = trimTrailingSlash(process.env.REACT_APP_API_BASE_URL);
    if (/^https?:\/\//i.test(raw) || raw.startsWith("/")) {
      return raw;
    }
    // Ensure a leading slash for relative values like "backend" -> "/backend"
    return `/${raw}`;
  }

  if (typeof window === "undefined") {
    return "/backend";
  }

  const localPath = `${localBasePath()}/backend`;
  const isReactDevServer = window.location.hostname === "localhost" && window.location.port === "3000";

  // When running the React dev server on localhost:3000, return the relative
  // `/backend` path so the `setupProxy` (or `proxy` in package.json) forwards
  // requests to the Apache site (http://localhost/Ashoka).
  if (isReactDevServer) {
    return localPath; // '/backend' -> proxy will route to Apache
  }

  return `${window.location.origin}${localPath}`;
}

export function adminApiBaseUrl() {
  return `${backendBaseUrl()}/admin`;
}
